import { Link, Tabs, Text } from 'platform-components';
import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { matchPath } from 'react-router-dom';
import ym from 'react-yandex-metrika';

import { TABS } from '../typings';

import './class__tabs.scss';

interface OwnProps extends WithRouterPathHOC {}

export class ClassTabs extends React.Component<OwnProps> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    getCurrentTab = (): TABS | null => {
        const {
            location: { pathname },
        } = this.props;
        const {
            staticUrls: { labClassStudents, labClassTeachers, labClassSubjects },
        } = this.context;

        const isStudentsPath = matchPath(pathname, { path: labClassStudents });
        const isTeachersPath = matchPath(pathname, { path: labClassTeachers });
        const isSubjectsPath = matchPath(pathname, { path: labClassSubjects });

        if (isStudentsPath) {
            return TABS.STUDENTS;
        } else if (isTeachersPath) {
            return TABS.TEACHERS;
        } else if (isSubjectsPath) {
            return TABS.SUBJECTS;
        }

        return null;
    };

    handleTabClick = (tabId: TABS): void => {
        let goalId;

        switch (tabId) {
            case TABS.STUDENTS:
                goalId = 'teacher_my_students_class_my_students';

                break;
            case TABS.SUBJECTS:
                goalId = 'teacher_my_students_class_my_subjects';

                break;
            case TABS.TEACHERS:
                goalId = 'teacher_my_students_class_teachers';

                break;
            default:
                break;
        }

        if (goalId) {
            ym('reachGoal', goalId);
        }
    };

    render() {
        const { getRouterPath } = this.props;
        const {
            staticUrls: { labClassStudents, labClassTeachers, labClassSubjects },
        } = this.context;

        const currentTab = this.getCurrentTab();

        // такое бывает при редиректе с empty state (lab/classes) = добавление первого класса
        // возникает так как withRouter не обновляется при редиректе
        if (!currentTab) {
            return null;
        }

        return (
            <Tabs mix="class__tabs" withDivider={true}>
                <Link
                    isRouter
                    mix="class__tabs-link"
                    onClick={() => this.handleTabClick(TABS.STUDENTS)}
                    theme={Link.THEME.INHERIT}
                    to={getRouterPath(labClassStudents)}
                >
                    <Tabs.Tab
                        id={TABS.STUDENTS}
                        mix="class__tab qa_class-tab-students"
                        selected={currentTab === TABS.STUDENTS}
                    >
                        <Text id="class.tabs.students" />
                    </Tabs.Tab>
                </Link>
                <Link
                    isRouter
                    mix="class__tabs-link"
                    onClick={() => this.handleTabClick(TABS.TEACHERS)}
                    theme={Link.THEME.INHERIT}
                    to={getRouterPath(labClassTeachers)}
                >
                    <Tabs.Tab
                        id={TABS.TEACHERS}
                        mix="class__tab qa_class-tab-teachers"
                        selected={currentTab === TABS.TEACHERS}
                    >
                        <Text id="class.tabs.teachers" />
                    </Tabs.Tab>
                </Link>
                <Link
                    isRouter
                    mix="class__tabs-link"
                    onClick={() => this.handleTabClick(TABS.SUBJECTS)}
                    theme={Link.THEME.INHERIT}
                    to={getRouterPath(labClassSubjects)}
                >
                    <Tabs.Tab
                        id={TABS.SUBJECTS}
                        mix="class__tab qa_class-tab-subjects"
                        selected={currentTab === TABS.SUBJECTS}
                    >
                        <Text id="class.tabs.subjects" />
                    </Tabs.Tab>
                </Link>
            </Tabs>
        );
    }
}

// @ts-ignore
export default withRouterPath(ClassTabs);
